module.exports = __webpack_public_path__ + "img/icon_attach_file_off.030ae32d.svg";